export default __webpack_public_path__ + "static/media/house_white.76640842.svg";